"use client";

import Link from "next/link";
import { useRouter } from "next/navigation";
import { ChevronLeft } from "@/components/ui/icons";

interface BackButtonProps {
  label: string;
  /** Navigate to a specific route. Omit to use browser back. */
  href?: string;
  /** Optional crumb after the back label (e.g. tool category). */
  trail?: { label: string; href: string };
}

/** "‹ Label" back control used at the top of detail screens. */
export function BackButton({ label, href, trail }: BackButtonProps) {
  const router = useRouter();
  const backClassName =
    "inline-flex cursor-pointer items-center gap-1.5 rounded-[10px] py-2 pl-2 pr-2 text-[13.5px] font-semibold text-ink-3 transition-colors hover:bg-[rgba(17,17,17,0.04)]";

  const back = href ? (
    <Link href={href} className={backClassName}>
      <ChevronLeft size={16} />
      <span>{label}</span>
    </Link>
  ) : (
    <button type="button" onClick={() => router.back()} className={backClassName}>
      <ChevronLeft size={16} />
      <span>{label}</span>
    </button>
  );

  if (!trail) {
    return <div className="mb-3.5">{back}</div>;
  }

  return (
    <nav className="mb-3.5 flex flex-wrap items-center gap-1" aria-label="Breadcrumb">
      {back}
      <span className="select-none text-[13.5px] font-semibold text-muted-2" aria-hidden="true">
        /
      </span>
      <Link
        href={trail.href}
        className="inline-flex cursor-pointer items-center rounded-[10px] px-2 py-2 text-[13.5px] font-semibold text-ink-3 transition-colors hover:bg-[rgba(17,17,17,0.04)]"
      >
        {trail.label}
      </Link>
    </nav>
  );
}
